import script from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestDemo.vue?vue&type=script&setup=true&lang=js"

import "./RequestDemo.vue?vue&type=style&index=0&id=19adb426&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19adb426"]])

export default __exports__